/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingFilteredAssetsQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.AssetConfigFilter>;
	order?: Types.InputMaybe<Array<Types.AssetConfigOrder> | Types.AssetConfigOrder>;
}>;

export type GetStakingFilteredAssetsQuery = {
	__typename?: "Query";
	balances: Array<{
		__typename?: "StakingBalance";
		rewardsAmount: {
			__typename?: "RewardsAmount";
			totalCurrent: {
				__typename?: "Balance";
				asset: { __typename?: "CurrencyAmount"; value: string };
				fiat: { __typename?: "FiatAmount"; value: string };
			};
			totalLastMonth: {
				__typename?: "Balance";
				asset: { __typename?: "CurrencyAmount"; value: string };
				fiat: { __typename?: "FiatAmount"; value: string };
			};
		};
	}>;
	assetConfig: {
		__typename?: "AssetConfigResponse";
		stakingEnabled?: boolean | null;
		enabledForUserCountry?: boolean | null;
		assets?: Array<{
			__typename?: "StakeableAsset";
			assetId: string;
			availability: string;
			stakingMode: Types.StakingMode;
			yearlyInterest: number;
			rewardIntervalInDays: number;
			stakingType: Types.StakingType;
			unboundPeriod?: number | null;
			isAutoStakingEnabled: boolean;
			minStakingAmount: { __typename?: "CurrencyAmount"; value: string };
			nextReward: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		}> | null;
	};
};

export const GetStakingFilteredAssetsDocument = gql`
	query getStakingFilteredAssets($filter: AssetConfigFilter, $order: [AssetConfigOrder!]) {
		balances {
			rewardsAmount {
				totalCurrent {
					asset {
						value
					}
					fiat {
						value
					}
				}
				totalLastMonth {
					asset {
						value
					}
					fiat {
						value
					}
				}
			}
		}
		assetConfig(filter: $filter, order: $order) {
			stakingEnabled
			enabledForUserCountry
			assets {
				assetId
				availability
				stakingMode
				yearlyInterest
				minStakingAmount {
					value
				}
				nextReward {
					iso8601
					unixTimestamp
				}
				rewardIntervalInDays
				stakingType
				unboundPeriod
				isAutoStakingEnabled
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingFilteredAssetsGQLService extends Apollo.Query<
	GetStakingFilteredAssetsQuery,
	GetStakingFilteredAssetsQueryVariables
> {
	document = GetStakingFilteredAssetsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
